module.exports = __webpack_public_path__ + "d3e883b98f29c72acae4543b2989ad64.eot";


//////////////////
// WEBPACK FOOTER
// ./client/Site/Style/fonts/geo-webfont/geo-regular.eot
// module id = 21
// module chunks = 0